// extracted by mini-css-extract-plugin
module.exports = {"tab":"manage-members-tab_tab__1UwXi"};